module.exports = __webpack_public_path__ + "img/count-place-icon.b4000fff.svg";